import { Component, OnInit } from "@angular/core";
import "devextreme/data/odata/store";
import { formatMessage } from "devextreme/localization";

@Component({
  templateUrl: "tasks.component.html",
})
export class TasksComponent implements OnInit {
  formatMessage = formatMessage;
  ngOnInit(): void {}
}
